import { enUS } from 'date-fns/locale';

export default {
  'durability-language': enUS,
  'hello': 'Hello, {username}.',
  'comfort': 'Comfort',
  'comfortable': 'Comfortable',
  'intermediary': 'Intermediary',
  'critical': 'Critical',
  'alert': 'Alert',
  'no_data': 'No Data',
  'lethal': 'Lethal',
  'aviaries': 'Aviaries',
  'aviary': 'Aviary',
  'loading_properties': 'Loading properties',
  'none_found': 'No properties were found',
  'empty_batch': 'Empty Batch',
  'pre_lodged': 'Pre-lodged',
  'lodged': 'Lodged',
  'slaughter': 'Slaughter',
  'storage': 'Storage',
  'simulation': 'Simulation',
  'target_weight': 'Target Weight',
  'target_value': 'Necessary Feed',
  'entry_weight': 'Entry Weight',
  'weekly_weight_projection': 'Weight Projection by Age',
  'leave_weight': 'Exit Weight',
  'leave_age': 'Exit Age',
  'filtros': 'Filters',
  'aviaries_page': 'Aviaries per Page',
  'rations_page': 'Rations per Page',
  'stage': 'Stage',
  'conversionFactor': 'Conversion Factor',
  'bed_temperature': 'Bed Temperature',
  'water_temperature': 'Water Temperature',
  'ambient-humidity': 'Ambient Humidity',
  'ambient-temperature': 'Ambient Temperature',
  'humidity-ambient-temperature': 'Ambient Humidity and Temperature',
  'shed': 'Shed',
  'ambience': 'Ambience',
  'ambient': 'Ambience',
  'humidity': 'Humidity',
  'message': 'Message',
  'alerts': 'Alerts',
  'creation_date': 'Creation Date',
  'dateTime': 'Date and Time',
  'qty24h': 'Last 24h',
  'type': 'Type',
  'subtype': 'Subtype',
  'lineage': 'Lineage',
  'sex': 'Sex',
  'age': 'Age',
  'real_age': 'Chickens Age',
  'batch_age': 'Batch Age',
  'weight': 'Weight',
  'dwg': 'D.W.G.',
  'alerts/recent': 'Alerts',
  'alerts/history': 'Alert History',
  'recent': 'Recent',
  'uniformity': 'Uniformity',
  'performance': 'Performance',
  'producer': 'Producer',
  'city': 'City',
  'greater_than': 'Greater than',
  'less_than': 'Less than',
  'alertTypeQty': 'Alert Types',
  'totalQty': 'Total Quantity',
  'quantityNf': 'Quantity NF',
  'quantityTotalDeliveredNf': 'Total Delivered Feed NF',
  'total_delivered': 'Total Delivered',
  'exactly': 'Exactly',
  'and': 'AND',
  'or': 'OR',
  'add': 'Add',
  'remove': 'Remove',
  'identification': 'Identification',
  'address': 'Address',
  'contact': 'Contact',
  'sub_region': 'Sub-region',
  'lodge': 'Lodge',
  'current_lodge': 'Current Lodge',
  'date': 'Date',
  'effective_weight': 'Effective Weight',
  'nutrition': 'Nutrition',
  'sanity': 'Sanity',
  'logout': 'Logout',
  'loading': 'Loading',
  'en': 'English',
  'es': 'Spanish',
  'pt-br': 'Portuguese',
  'slaughter_forecast': 'Slaughter Forecast',
  'forecast': 'Forecast',
  'close': 'Close',
  'last_projected_weight': 'Last Projected Weight',
  'actions': 'Actions',
  'predicted_weight': 'Predicted Weight',
  'select_a_date': 'Select a Date',
  'days': 'Days',
  'production_days': 'Production Days',
  'weeks': 'Weeks',
  'production_weeks': 'Production Weeks',
  'production_time': 'Production Time',
  'prediction': 'Prediction',
  'predictions': 'Predictions',
  'fwu': 'F.W.U.',
  'search': 'Search',
  'broiler': 'Broiler Chicken',
  'broiler_chicken': 'Broiler Chicken',
  'matrix': 'Breeder',
  'swine': 'Swine',
  'swines': 'Swines',
  'home': 'Home',
  'status': 'Status',
  'silo': 'Silo',
  'ration': 'Ration',
  'rationType': 'Ration Type',
  'capacity': 'Capacity',
  'free': 'Free',
  'available': 'Available',
  'last_received_time': 'Last Reading',
  'occupation': 'Occupation',
  'expected_end_date': 'Expected End Date',
  'full': 'Full',
  'low': 'Low',
  'satisfactory': 'Satisfactory',
  'last_ration_delivered': 'Last Ration Delivered',
  'ration_delivered': 'Ration Delivered',
  'consumed': 'Consumed',
  'pre_initial': 'Pre-Initial',
  'initial': 'Initial',
  'growth': 'Growth',
  'general': 'General',
  'male': 'Male',
  'female': 'Female',
  'production_chicken': 'Production Birds',
  'hatch_chicken': 'Breeding Birds',
  'production': 'Production',
  'hatch': 'Hatch',
  'production_type': 'Production Type',
  'airsacculitis': 'Airsacculitis',
  'contaminated': 'Contaminated Birds',
  'total_delivered_ration': 'Total Delivered Ration',
  'total_consumed': 'Total Consumed',
  'core': 'Core',
  'pcp': 'PCP Planning',
  'pcp_filter': 'PCP',
  'dwg_filter': 'DWG',
  'weighing': 'Weighing',
  'StorageCapacity': 'Storage Capacity',
  'TotalFeedInTheField': 'Total Feed in the Field',
  'TotalFree': 'Total Free',
  'nutritionTotals': 'Totals',
  'total_free': 'Total Available',
  'siloRead': 'Silo Reading',
  'addRationDelivery': 'Register Ration Delivery',
  'last_read': 'Last Reading',
  'period': 'Period',
  'from': 'From',
  'until': 'Until',
  'predictedEndOfFeed': 'Ration End Prediction',
  'update': 'Update',
  'groupBy': 'Group By',
  'last_days': 'Last Days',
  'between': 'Between',
  'silo_1': 'Silo 1',
  'silo_2': 'Silo 2',
  'average_consumption': 'Average Consumption',
  'average_consumption_per_animal': 'Average Consumption per Animal',
  'total': 'Total',
  'occupation_history': 'Ration Consumption',
  'occupation_percent': 'Occupation (%)',
  'week': 'Week',
  'age_range': 'Age Range',
  'cancel': 'Cancel',
  'phase': 'Phase',
  'density': 'Density',
  'semi_annual_planning': 'Weekly Planning',
  'generateReport': 'Generate Report',
  'target_date': 'Target Date/Time',
  'target_age': 'Target Age',
  'need_for_feed': 'Feed Needed',
  'accumulated_consumption': 'Accumulated Consumption',
  'weight_prediction': 'Weight Prediction',
  'target_weight_prediction': 'Predicted Weight',
  'target_weight_company': 'Company Target Weight',
  'laying-birds': 'Laying Birds',
  'alerts-history': 'Alerts History',
  'production_birds': 'Production Birds',
  'breeding_birds': 'Breeding Birds',
  'Comfortable': 'Comfortable',
  'Intermediary': 'Intermediary',
  'Critical': 'Critical',
  'Lethal': 'Lethal',
  'login': 'Login',
  'login_title': 'Login to your account.',
  'username': 'Username',
  'username_placeholder': 'username',
  'password': 'Password',
  'password_placeholder': 'password',
  'comfort_map': 'Comfort map',
  'amplitude': 'Amplitude',
  'last_reading': 'Last reading',
  'percent': 'Percent',
  'property': 'Property',
  'amount_lodge': 'Amount Lodge',
  'occupation_history1': 'Occupation History',
  'weekAge': 'Age (week)',
  'currentLodge': 'Current Lodge',
  'weeklyConsumption': 'Average weekly consumption (Shed/animal)',
  'Aves poedeiras - recria': 'Breeding',
  'Aves poedeiras - produção': 'Laying',
  'endOfRationForecast': 'Ration End Forecast',
  'durability': 'Durability',
  'addAlert': 'Add Alert',
  'real': 'Real',
  'reference': 'Reference',
  'consumptionByAnimal': 'Consumption per Animal',
  'occupation%': 'Occupation (%)',
  'rationEndPrediction': 'Ration End Prediction',
  'availableRation': 'Available Ration',
  'daily': 'Daily',
  'weekly': 'Weekly',
  'gain': 'Gain',
  'averageWeight': 'Average Weight',
  'batch': 'Batch',
  'batch start': 'Batch Start',
  'last 24h': 'Last 24h',
  'first_name': 'First Name',
  'last_name': 'Last Name',
  'document': 'Document (CPF)',
  'ddd_phone': 'Area Code',
  'phone': 'Phone',
  'ddd_cellphone': 'Area Code',
  'cellphone': 'Cellphone',
  'profile': 'Profile',
  'edit': 'Edit',
  'save': 'Save',
  'current_password': 'Current Password',
  'new_password': 'New Password',
  'confirm_password': 'Confirm New Password',
  'change_password': 'Change Password',
  'userdata_loading_error': 'Error loading user data',
  'update_profile_error': 'Error updating profile',
  'password_match_error': 'Passwords do not match',
  'password_error': 'Error changing password',
  'document_error': 'Invalid CPF number',
  'start': 'Start',
  'end': 'End',
  'last-days': 'Last Days',
  'group-per-days': 'Group by Days',
  'group-per-weeks': 'Group by Weeks',
  'Bateria': 'Battery',
  'aviaryShed': 'Aviary/Shed',
  'noData': 'No data available',
  'propertyOwner': 'Producer',
  'selectSilo': 'Select silo',
  'no-data': 'No Data',
  'consumption': 'Consumption',
  'division': 'Division',
  'breedingType': 'Breeding',
  'performance-male-female': 'Performance Male/Female',
  'idealWeightRef': 'Ideal Weight (Reference)',
  'idealWeight': 'Ideal Weight',
  'dailyWeight': 'Daily weight',
  'day': 'Day',
  'weeklyWeight': 'Weekly weight',
  'histogram': 'Histogram',
  'weightRanges': 'Weight ranges',
  'frequency': 'Frequency',
  'sheds': 'Sheds',
  'productionType': 'Production Type',
  'select_sex': 'Select sex',
  'select_lineage': 'Select lineage',
  'name': 'Nombre',
  'description': 'Descripción',
  'entryWeight': 'Peso de entrada',
  'startingAge': 'Edad inicial',
  'openingDate': 'Fecha de apertura',
  'closingDate': 'Fecha de cierre',
  'editShed': 'Edit shed',
  'editBatch': 'Edit batch',
  'addBatch': 'Add batch',
  'amountLodge': 'Amount lodge',
  'selectProductionType': 'Select production type',
  'selectBreedingType': 'Select breeding type',
  'effectiveWeight': 'Effective Weight',
  'closingBeforeOpeningError': 'Closing date cannot be earlier than opening date.',
  'view': 'View',
  'freeWeight': 'Free',
  'previous': 'Previous',
  'next': 'Next',
  'page': 'Page',
  'mortalityControl': 'Mortality Control',
  'mortality': 'Mortality',
  'amountEliminated': 'Amount Eliminated',
  'amountMortality': 'Amount of Mortality',
  'dataSaved': 'Data saved successfully',
  'addMortality': 'Add Mortality',
  'openBatch': 'Open Batch',
  'closeBatch': 'Close Batch',
  'closingBatch': 'Closing Batch',
  'amount_lodged': 'Amount Lodged',
  'enthalpy': 'Enthalpy',
  'rationManagement': 'Ration Management',
  'confirmDelete': 'Confirm Deletion',
  'deleteMessage': 'Are you sure you want to delete this record?',
  'deliveryWeight': 'Delivery Weight',
  'plan': 'Plan',
  'link_batch': 'Link Batch',
  'plans_page': 'Plans per page',
  'nutritionalWeeklyConsumption': 'Weekly consumption',
  'attention': 'Attention',
  'ration_edit_confirmation_message': 'When editing ration information, all data (consumption, feed conversion, etc.) for current and previous batches related to this ration will be recalculated. Are you sure about this action? Type the ration name to confirm.',
  'type_here': 'Type here',
  'water_consumption' : 'Water consumption',
  'water_total_batch' : 'Total batch consumption',
  'water_per_bird' : 'Consumption total per bird',
  'water_liters_per_bird' : 'L/bird',
  'water_hourly_24h' : 'Hourly consumption - last 24 hours',
  'water_load_error' : 'Could not load water consumption',
  'water_history' : 'Water consumption history',
  'water_daily_total' : 'Daily batch consumption',
  'water_daily_per_bird' : 'Daily consumption per bird',
  'water_weekly_total' : 'Weekly batch consumption',
  'water_weekly_per_bird' : 'Weekly consumption per bird',
  'water_milliliters_per_bird' : 'ml/bird',
  'water_history_load_error' : 'Could not load water consumption history',
};
